import { z } from 'zod';

// ---------------------------------------------------------------------------
// Archive Conversations
// ---------------------------------------------------------------------------

export const archiveHubIdParam = z.object({
  hubId: z.string().uuid(),
});

export const archiveConversationParams = z.object({
  hubId: z.string().uuid(),
  conversationId: z.string().uuid(),
});

export const archiveListQuery = z.object({
  user_id: z.string().optional(),
  start: z.string().optional(),
  end: z.string().optional(),
  page: z.string().regex(/^\d+$/).optional(),
  page_size: z.string().regex(/^\d+$/).optional(),
});

export const archiveMessageObservabilityParams = archiveConversationParams.extend({
  messageId: z.string().uuid(),
});

// ---------------------------------------------------------------------------
// Inferred types
// ---------------------------------------------------------------------------

export type ArchiveHubIdParam = z.infer<typeof archiveHubIdParam>;
export type ArchiveConversationParams = z.infer<typeof archiveConversationParams>;
export type ArchiveListQuery = z.infer<typeof archiveListQuery>;
export type ArchiveMessageObservabilityParams = z.infer<typeof archiveMessageObservabilityParams>;

// ---------------------------------------------------------------------------
// Response types
// ---------------------------------------------------------------------------

export interface ArchivedConversationItem {
  conversation_id: string;
  user_id: string;
  hub_type: string;
  subject: string;
  /** A task conversation's title (wayai#4640); null or absent when it has none. */
  title?: string | null;
  conversation_status: string;
  kanban_status: string | null;
  created_at: string;
  ended_at: string | null;
  archived_at: string | null;
  message_count: number;
}

/** GET /:hubId/conversations */
export interface ArchiveListResponse {
  conversations: ArchivedConversationItem[];
  total: number;
  page: number;
  page_size: number;
}

/**
 * GET /:hubId/conversations/:conversationId
 *
 * The detail payload is an opaque JSON blob written by the archive job.
 * We type it as `Record<string, unknown>` since the shape is not
 * constrained at the API contract level.
 */
export type ArchiveDetailResponse = Record<string, unknown>;
